import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        ROUTERNAME: "offLine",
        MAINTENANCETAG: 'remoteUpgradeFile',
        TOKEN: null, // sid
        USER: localStorage.getItem("USER") ? JSON.parse(localStorage.getItem("USER")) : null, //用户信息
        GROUPLIST: [], //当前车组组织
        USERLIST: [], //当前用户列表
        KEEPALIVE: ["index"], //keepAlive 页面缓存配置
        NUMBER:4,//判断实时监控数据展示个数
        addressArr:[],
        activeCls:'',
    },
    mutations: {
        COMMIT_ACTIVE_CLS(state,data){
            state.activeCls = data;
        },
        COMMIT_ADDRESS(state,data){
            state.addressArr = data;
        },
        COMMIT_ROUTERNAME(state, val) {
            state.ROUTERNAME = val;
        },
        COMMIT_MAINTENANCETAG(state, val) {
            state.MAINTENANCETAG = val;
        },
        COMMIT_TOKEN(state, val) {
            state.TOKEN = Object.freeze(val);
        },
        COMMIT_USER(state, val) {
            val ? localStorage.setItem("USER", JSON.stringify(val)) : localStorage.removeItem("USER");
            state.USER = val;
        },
        COMMIT_GROUPLIST(state, val) {
            state.GROUPLIST = Object.freeze(val);
        },
        COMMIT_USERLIST(state, val) {
            state.USERLIST = Object.freeze(val);
        },
        COMMIT_KEEPALIVE(state, val) {
            state.KEEPALIVE = val;
        },
        COMMIT_NUMBER(state, val) {
            state.NUMBER = val == 'GPRS-HERCULES'|| val == 'GPRS-SUNWODA'?6:4;
        },
    },
    actions: {
        //清除页面缓存
        async DISPATCH_CLEARCHACE({ commit, state }, { Vue }) {
            await Vue.$nextTick();
            commit("COMMIT_GROUPLIST", []);
            commit("COMMIT_USERLIST", []);
            commit("COMMIT_USER", null);

            const KEEPALIVE = [...state.KEEPALIVE];
            commit("COMMIT_KEEPALIVE", []);
            await Vue.$nextTick();
            commit("COMMIT_KEEPALIVE", KEEPALIVE);
        }
    },
    modules: {},
});